module.exports = __webpack_public_path__ + "static/media/img.fffce63d.png";